import { Injectable } from '@angular/core';
import { getTimezone } from '../../../dataprotection-common/utils';
import { HttpUtils } from '../../../../../../common/http/http-utils';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class Service {
  value = '';

  constructor(public http: HttpClient) {
  }

  getRestorePointsForVm(vmId, vcId) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vc/' + vcId + '/vm/' + vmId + '/backup?timezone=' + encodeURIComponent(getTimezone());
    return this.http
      .get(url)
      .map(
        (res:any) => this.value = res
      );
  }

  getRestorePointsForDeletedVm(vmId, vcId) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vc/' + vcId + '/vm/' + vmId + '/backup?timezone=' + encodeURIComponent(getTimezone());
    return this.http
      .get(url)
      .map(
        (res:any) => this.value = res
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/common-ops/restore-points/restore-points.service.ts